export const Test = () => {
    return <h1 style={{ width: '100%', textAlign: 'center' }}>Ooops</h1>
}